import { Paper, Grid, TextFieldProps, TextField, Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { ProjectDivider } from 'spw-components/project-details-tabs/project-profile/styles';
import { Column, Row, SPWInput } from 'spw-shared/globalComponents';
import { colors } from 'spw-theme';
import styled from 'styled-components';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { globalInputLabelProps } from 'spw-shared/globalComponents/forms';
import { JustifyEndRow } from 'spw-shared/globalComponents/grid';

export const HeaderBuildingColumn = styled(Column)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 36px;

    color: #919191;
    align-items: left;
    justify-content: left;
    flex: 1;
  }
`;

export const ScenarioName = styled.span`
  && {
    color: ${colors.black};
  }
`;

export const CustomEditIcon = styled(EditIcon)`
  margin-left: 11px;
  color: ${colors.mainBlue};
  cursor: ${(props: { disabled?: boolean }) =>
    props.disabled ? 'inherit' : 'pointer'};
  color: ${(props: { disabled?: boolean }) =>
    props.disabled ? colors.mainGray : colors.mainBlue};
`;

export const CustomPaper = styled(Paper)`
  && {
    padding: 24px 24px 24px 16px;
    background-color: white !important;
  }
`;

export const Wrapper = styled.div`
  padding-bottom: ${(props: { paddingBottom?: number }) =>
    props.paddingBottom === undefined ? 80 : props.paddingBottom}px;
`;

export const USFBuildingTitle = styled(Column)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
`;
export const ColumnFlex1 = styled(Column)`
  && {
    flex: 1;
  }
`;

export const XSmallSPWInput = styled(SPWInput)`
  && {
    background: white;
    width: 89px;
    min-width: 89px;
    height: 40px !important;
    display: inline-flex;

    &.mt-10 {
      .MuiOutlinedInput-root {
        margin-top: 10px;
      }
    }

    .MuiInputBase-input {
      padding-left: 20px;
      background: ${colors.white};
    }

    .MuiOutlinedInput-input {
      text-align: ${(props: { textAlign?: 'center' | 'left' | 'right' }) =>
        props.textAlign || 'center'};
      height: 40px;
      font-size: 14px;
      line-height: 16px;
      padding: 0px 8px;
    }
  }
`;

export const FactorInput = withStyles(
  (props: TextFieldProps) => (
    <TextField
      {...props}
      InputLabelProps={globalInputLabelProps}
      variant="outlined"
    />
  ),
  {
    root: {
      height: '40px',
      width: '100px',
      '& .MuiInputBase-adornedEnd': {
        paddingRight: '8px',
        background: colors.teal,
        color: colors.mainBlue,
        cursor: 'pointer',
      },

      '& .MuiInputBase-input': {
        background: colors.teal,
        color: colors.black,
      },
      '& .MuiOutlinedInput-input': {
        height: '40px',
        fontSize: '14px',
        lineHeight: '16px',
        padding: '0px 0px 0px 12px',
      },
      '& .MuiInputAdornment-positionEnd': {
        marginLeft: '0px',
      },
      '& .Mui-disabled': {
        color: colors.mainGray,
      },
    },
  }
);

export const RowWithTopMargin = styled(Grid)`
  && {
    margin-top: 4px;
    border-radius: 8px;
    padding: 12px 12px 12px 8px;
    width: 94%;
    justify-content: space-between;

    &.gray-bg {
      background: #f7f7f7;
    }
  }
`;

export const CenteredColumn = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FlexEndColumn = styled(CenteredColumn)`
  justify-content: flex-end;
`;

export const SignColumn = styled(Column)`
  && {
    padding-right: 10px;
    padding-bottom: 7px;
    align-items: center;

    &.input,
    &.readonly {
      padding-bottom: 12px;
    }
  }
`;

export const TextColumn = styled(Column)`
  && {
    padding: 6px 0px 7px 0px;
  }
`;

export const BlackText = styled.span`
  && {
    color: ${colors.black};
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
  }

  &.positive {
    color: ${colors.mainGreen};
  }

  &.negative {
    color: ${colors.red};
  }
`;

export const BlackTextEditableUsf = styled(BlackText)`
  && {
    display: flex;
    align-items: center;
  }
`;

export const TitleText = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: rgba(97, 97, 101, 0.87);
    width: 100px;
  }
`;

export const OperationText = styled.span`
  && {
    color: ${colors.black};
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const GreyText = styled.span`
  && {
    color: ${colors.greyInputAddornment};
  }
`;

export const USFCustomDivider = styled(ProjectDivider)`
  && {
    margin-top: 4px;
  }
`;

export const CenteredTd = styled.td`
  && {
    text-align: center;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Th10 = styled.th`
  && {
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-align: center;
    width: 50%;
  }
`;

export const Row10TopPadding = styled(Row)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    margin-top: 10px;
  }
`;

export const RowBold = styled(Row)`
  && {
    text-transform: uppercase;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
`;

export const Row5TopPadding = styled(Row)`
  && {
    margin-top: 5px;
  }
`;

export const USFLabel = styled.span`
  && {
    color: ${colors.mainBlue};
    font-weight: bold;
  }
`;

export const ButtonColumn = styled(Column)`
  && {
    padding-right: 16px;
  }
`;

export const LeftArrow = styled.span`
  && {
    margin: 0 14px;
  }
`;

export const TitleName = styled.span`
  && {
    text-transform: capitalize;
    cursor: pointer;
  }
`;

export const LinkedButton = styled(Button)`
  && {
    border-radius: 3px;
    width: 104px;
    height: 36px;

    div {
      margin-left: 8px;
    }
  }

  &.MuiButton-root:hover {
    background-color: rgba(0, 129, 158, 0.1);
  }
`;

export const PopoverHeader = styled.div`
  && {
    font-family: Roboto;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    display: flex;
    align-items: center;

    /* black */

    color: #000000;

    margin-bottom: 6px;

    text-transform: uppercase;
  }
`;

export const PopoverContent = styled.div`
  && {
    font-family: Roboto;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    /* black */

    color: #000000;
  }
`;

export const PopoverInnerWrapper = styled.div`
  && {
    width: 174px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const AddOrRemoveRsfBtnContainer = styled.div`
  && {
    margin-top: 15px;
  }
`;

export const CalculatorActionsWrapper = styled(JustifyEndRow)`
  .download-button-wrapper {
    width: 133px;
    margin-left: 4px;
    text-align: center;

    .MuiButton-root {
      width: 134px;
      padding: 10px 16px;
    }
  }
`;
